{
  "items": [
    {
      "city": "Tallinn",
      "lat": "59.4372",
      "lng": "24.7450",
      "country": "Estonia",
      "iso2": "EE",
      "admin_name": "Harjumaa",
      "capital": "primary",
      "population": "438341",
      "population_proper": "438341"
    },
    {
      "city": "Tartu",
      "lat": "58.3800",
      "lng": "26.7225",
      "country": "Estonia",
      "iso2": "EE",
      "admin_name": "Tartumaa",
      "capital": "admin",
      "population": "91407",
      "population_proper": "91407"
    },
    {
      "city": "Narva",
      "lat": "59.3792",
      "lng": "28.2006",
      "country": "Estonia",
      "iso2": "EE",
      "admin_name": "Ida-Virumaa",
      "capital": "minor",
      "population": "53424",
      "population_proper": "53424"
    },
    {
      "city": "Pärnu",
      "lat": "58.3844",
      "lng": "24.4989",
      "country": "Estonia",
      "iso2": "EE",
      "admin_name": "Pärnumaa",
      "capital": "admin",
      "population": "39438",
      "population_proper": "39438"
    },
    {
      "city": "Kohtla-Järve",
      "lat": "59.4000",
      "lng": "27.2833",
      "country": "Estonia",
      "iso2": "EE",
      "admin_name": "Ida-Virumaa",
      "capital": "minor",
      "population": "32577",
      "population_proper": "32577"
    },
    {
      "city": "Viljandi",
      "lat": "58.3633",
      "lng": "25.5956",
      "country": "Estonia",
      "iso2": "EE",
      "admin_name": "Viljandimaa",
      "capital": "admin",
      "population": "16875",
      "population_proper": "16875"
    },
    {
      "city": "Maardu",
      "lat": "59.4781",
      "lng": "25.0161",
      "country": "Estonia",
      "iso2": "EE",
      "admin_name": "Harjumaa",
      "capital": "minor",
      "population": "15284",
      "population_proper": "15284"
    },
    {
      "city": "Rakvere",
      "lat": "59.3506",
      "lng": "26.3611",
      "country": "Estonia",
      "iso2": "EE",
      "admin_name": "Lääne-Virumaa",
      "capital": "admin",
      "population": "14984",
      "population_proper": "14984"
    },
    {
      "city": "Kuressaare",
      "lat": "58.2533",
      "lng": "22.4861",
      "country": "Estonia",
      "iso2": "EE",
      "admin_name": "Saaremaa",
      "capital": "admin",
      "population": "13097",
      "population_proper": "13097"
    },
    {
      "city": "Sillamäe",
      "lat": "59.3931",
      "lng": "27.7742",
      "country": "Estonia",
      "iso2": "EE",
      "admin_name": "Ida-Virumaa",
      "capital": "minor",
      "population": "12230",
      "population_proper": "12230"
    },
    {
      "city": "Valga",
      "lat": "57.7769",
      "lng": "26.0311",
      "country": "Estonia",
      "iso2": "EE",
      "admin_name": "Valgamaa",
      "capital": "admin",
      "population": "12182",
      "population_proper": "12182"
    },
    {
      "city": "Võru",
      "lat": "57.8486",
      "lng": "26.9928",
      "country": "Estonia",
      "iso2": "EE",
      "admin_name": "Võrumaa",
      "capital": "admin",
      "population": "11533",
      "population_proper": "11533"
    },
    {
      "city": "Jõhvi",
      "lat": "59.3575",
      "lng": "27.4122",
      "country": "Estonia",
      "iso2": "EE",
      "admin_name": "Ida-Virumaa",
      "capital": "admin",
      "population": "10541",
      "population_proper": "10541"
    },
    {
      "city": "Keila",
      "lat": "59.3081",
      "lng": "24.4264",
      "country": "Estonia",
      "iso2": "EE",
      "admin_name": "Harjumaa",
      "capital": "minor",
      "population": "10078",
      "population_proper": "10078"
    },
    {
      "city": "Haapsalu",
      "lat": "58.9469",
      "lng": "23.5369",
      "country": "Estonia",
      "iso2": "EE",
      "admin_name": "Läänemaa",
      "capital": "admin",
      "population": "9675",
      "population_proper": "9675"
    },
    {
      "city": "Paide",
      "lat": "58.8833",
      "lng": "25.5667",
      "country": "Estonia",
      "iso2": "EE",
      "admin_name": "Järvamaa",
      "capital": "admin",
      "population": "7905",
      "population_proper": "7905"
    },
    {
      "city": "Tapa",
      "lat": "59.2644",
      "lng": "25.9628",
      "country": "Estonia",
      "iso2": "EE",
      "admin_name": "Lääne-Virumaa",
      "capital": "minor",
      "population": "5706",
      "population_proper": "5706"
    },
    {
      "city": "Elva",
      "lat": "58.2275",
      "lng": "26.4158",
      "country": "Estonia",
      "iso2": "EE",
      "admin_name": "Tartumaa",
      "capital": "minor",
      "population": "5669",
      "population_proper": "5669"
    },
    {
      "city": "Saue",
      "lat": "59.3231",
      "lng": "24.5622",
      "country": "Estonia",
      "iso2": "EE",
      "admin_name": "Harjumaa",
      "capital": "minor",
      "population": "5631",
      "population_proper": "5631"
    },
    {
      "city": "Kiviõli",
      "lat": "59.3517",
      "lng": "26.9611",
      "country": "Estonia",
      "iso2": "EE",
      "admin_name": "Ida-Virumaa",
      "capital": "minor",
      "population": "5504",
      "population_proper": "5504"
    },
    {
      "city": "Põlva",
      "lat": "58.0536",
      "lng": "27.0556",
      "country": "Estonia",
      "iso2": "EE",
      "admin_name": "Põlvamaa",
      "capital": "admin",
      "population": "5324",
      "population_proper": "5324"
    },
    {
      "city": "Türi",
      "lat": "58.8094",
      "lng": "25.4292",
      "country": "Estonia",
      "iso2": "EE",
      "admin_name": "Järvamaa",
      "capital": "minor",
      "population": "5257",
      "population_proper": "5257"
    },
    {
      "city": "Jõgeva",
      "lat": "58.7461",
      "lng": "26.3956",
      "country": "Estonia",
      "iso2": "EE",
      "admin_name": "Jõgevamaa",
      "capital": "admin",
      "population": "5073",
      "population_proper": "5073"
    },
    {
      "city": "Rapla",
      "lat": "58.9944",
      "lng": "24.8011",
      "country": "Estonia",
      "iso2": "EE",
      "admin_name": "Raplamaa",
      "capital": "admin",
      "population": "5069",
      "population_proper": "5069"
    },
    {
      "city": "Põltsamaa",
      "lat": "58.6533",
      "lng": "25.9722",
      "country": "Estonia",
      "iso2": "EE",
      "admin_name": "Jõgevamaa",
      "capital": "minor",
      "population": "4111",
      "population_proper": "4111"
    },
    {
      "city": "Paldiski",
      "lat": "59.3500",
      "lng": "24.0500",
      "country": "Estonia",
      "iso2": "EE",
      "admin_name": "Harjumaa",
      "capital": "minor",
      "population": "4056",
      "population_proper": "4056"
    },
    {
      "city": "Sindi",
      "lat": "58.4031",
      "lng": "24.6478",
      "country": "Estonia",
      "iso2": "EE",
      "admin_name": "Pärnumaa",
      "capital": "minor",
      "population": "4003",
      "population_proper": "4003"
    },
    {
      "city": "Kärdla",
      "lat": "58.9944",
      "lng": "22.7500",
      "country": "Estonia",
      "iso2": "EE",
      "admin_name": "Hiiumaa",
      "capital": "admin",
      "population": "3230",
      "population_proper": "3230"
    },
    {
      "city": "Kunda",
      "lat": "59.5008",
      "lng": "26.5275",
      "country": "Estonia",
      "iso2": "EE",
      "admin_name": "Lääne-Virumaa",
      "capital": "minor",
      "population": "3224",
      "population_proper": "3224"
    },
    {
      "city": "Kehra",
      "lat": "59.3369",
      "lng": "25.3283",
      "country": "Estonia",
      "iso2": "EE",
      "admin_name": "Harjumaa",
      "capital": "minor",
      "population": "2754",
      "population_proper": "2754"
    },
    {
      "city": "Tõrva",
      "lat": "58.0028",
      "lng": "25.9228",
      "country": "Estonia",
      "iso2": "EE",
      "admin_name": "Valgamaa",
      "capital": "minor",
      "population": "2690",
      "population_proper": "2690"
    },
    {
      "city": "Narva-Jõesuu",
      "lat": "59.4625",
      "lng": "28.0419",
      "country": "Estonia",
      "iso2": "EE",
      "admin_name": "Ida-Virumaa",
      "capital": "minor",
      "population": "2681",
      "population_proper": "2681"
    },
    {
      "city": "Räpina",
      "lat": "58.0978",
      "lng": "27.4642",
      "country": "Estonia",
      "iso2": "EE",
      "admin_name": "Põlvamaa",
      "capital": "minor",
      "population": "2312",
      "population_proper": "2312"
    },
    {
      "city": "Tamsalu",
      "lat": "59.1589",
      "lng": "26.1081",
      "country": "Estonia",
      "iso2": "EE",
      "admin_name": "Lääne-Virumaa",
      "capital": "",
      "population": "2197",
      "population_proper": "2197"
    },
    {
      "city": "Järveküla",
      "lat": "59.3889",
      "lng": "24.7967",
      "country": "Estonia",
      "iso2": "EE",
      "admin_name": "Harjumaa",
      "capital": "",
      "population": "1918",
      "population_proper": "1918"
    },
    {
      "city": "Otepää",
      "lat": "58.0572",
      "lng": "26.4983",
      "country": "Estonia",
      "iso2": "EE",
      "admin_name": "Valgamaa",
      "capital": "minor",
      "population": "1901",
      "population_proper": "1901"
    },
    {
      "city": "Randvere",
      "lat": "59.5089",
      "lng": "24.9064",
      "country": "Estonia",
      "iso2": "EE",
      "admin_name": "Harjumaa",
      "capital": "",
      "population": "1894",
      "population_proper": "1894"
    },
    {
      "city": "Muraste",
      "lat": "59.4547",
      "lng": "24.4394",
      "country": "Estonia",
      "iso2": "EE",
      "admin_name": "Harjumaa",
      "capital": "",
      "population": "1818",
      "population_proper": "1818"
    },
    {
      "city": "Pärnamäe",
      "lat": "59.5014",
      "lng": "24.8689",
      "country": "Estonia",
      "iso2": "EE",
      "admin_name": "Harjumaa",
      "capital": "",
      "population": "1739",
      "population_proper": "1739"
    },
    {
      "city": "Kilingi-Nõmme",
      "lat": "58.1497",
      "lng": "24.9614",
      "country": "Estonia",
      "iso2": "EE",
      "admin_name": "Pärnumaa",
      "capital": "minor",
      "population": "1709",
      "population_proper": "1709"
    },
    {
      "city": "Alliku",
      "lat": "59.3558",
      "lng": "24.5561",
      "country": "Estonia",
      "iso2": "EE",
      "admin_name": "Harjumaa",
      "capital": "",
      "population": "1651",
      "population_proper": "1651"
    },
    {
      "city": "Lohkva",
      "lat": "58.3725",
      "lng": "26.7936",
      "country": "Estonia",
      "iso2": "EE",
      "admin_name": "Tartumaa",
      "capital": "",
      "population": "1534",
      "population_proper": "1534"
    },
    {
      "city": "Karksi-Nuia",
      "lat": "58.1047",
      "lng": "25.5475",
      "country": "Estonia",
      "iso2": "EE",
      "admin_name": "Viljandimaa",
      "capital": "",
      "population": "1524",
      "population_proper": "1524"
    },
    {
      "city": "Tammiste",
      "lat": "58.3836",
      "lng": "24.6025",
      "country": "Estonia",
      "iso2": "EE",
      "admin_name": "Pärnumaa",
      "capital": "",
      "population": "1491",
      "population_proper": "1491"
    },
    {
      "city": "Antsla",
      "lat": "57.8292",
      "lng": "26.5289",
      "country": "Estonia",
      "iso2": "EE",
      "admin_name": "Võrumaa",
      "capital": "minor",
      "population": "1352",
      "population_proper": "1352"
    },
    {
      "city": "Püünsi",
      "lat": "59.5531",
      "lng": "24.7956",
      "country": "Estonia",
      "iso2": "EE",
      "admin_name": "Harjumaa",
      "capital": "",
      "population": "1327",
      "population_proper": "1327"
    },
    {
      "city": "Võhma",
      "lat": "58.6292",
      "lng": "25.5578",
      "country": "Estonia",
      "iso2": "EE",
      "admin_name": "Viljandimaa",
      "capital": "",
      "population": "1285",
      "population_proper": "1285"
    },
    {
      "city": "Lihula",
      "lat": "58.6878",
      "lng": "23.8342",
      "country": "Estonia",
      "iso2": "EE",
      "admin_name": "Läänemaa",
      "capital": "minor",
      "population": "1237",
      "population_proper": "1237"
    },
    {
      "city": "Mustvee",
      "lat": "58.8478",
      "lng": "26.9478",
      "country": "Estonia",
      "iso2": "EE",
      "admin_name": "Jõgevamaa",
      "capital": "minor",
      "population": "1221",
      "population_proper": "1221"
    },
    {
      "city": "Vastse-Kuuste",
      "lat": "58.1664",
      "lng": "26.9328",
      "country": "Estonia",
      "iso2": "EE",
      "admin_name": "Põlvamaa",
      "capital": "",
      "population": "1167",
      "population_proper": "1167"
    },
    {
      "city": "Rae",
      "lat": "59.3806",
      "lng": "24.8911",
      "country": "Estonia",
      "iso2": "EE",
      "admin_name": "Harjumaa",
      "capital": "",
      "population": "1158",
      "population_proper": "1158"
    },
    {
      "city": "Suurupi",
      "lat": "59.4692",
      "lng": "24.3839",
      "country": "Estonia",
      "iso2": "EE",
      "admin_name": "Harjumaa",
      "capital": "",
      "population": "1118",
      "population_proper": "1118"
    },
    {
      "city": "Vääna-Jõesuu",
      "lat": "59.4350",
      "lng": "24.3581",
      "country": "Estonia",
      "iso2": "EE",
      "admin_name": "Harjumaa",
      "capital": "",
      "population": "1116",
      "population_proper": "1116"
    },
    {
      "city": "Soinaste",
      "lat": "58.3428",
      "lng": "26.6997",
      "country": "Estonia",
      "iso2": "EE",
      "admin_name": "Tartumaa",
      "capital": "",
      "population": "1110",
      "population_proper": "1110"
    },
    {
      "city": "Papsaare",
      "lat": "58.4028",
      "lng": "24.4161",
      "country": "Estonia",
      "iso2": "EE",
      "admin_name": "Pärnumaa",
      "capital": "",
      "population": "1090",
      "population_proper": "1090"
    },
    {
      "city": "Tiskre",
      "lat": "59.4236",
      "lng": "24.5836",
      "country": "Estonia",
      "iso2": "EE",
      "admin_name": "Harjumaa",
      "capital": "",
      "population": "1064",
      "population_proper": "1064"
    },
    {
      "city": "Suure-Jaani",
      "lat": "58.5356",
      "lng": "25.4667",
      "country": "Estonia",
      "iso2": "EE",
      "admin_name": "Viljandimaa",
      "capital": "minor",
      "population": "1062",
      "population_proper": "1062"
    },
    {
      "city": "Abja-Paluoja",
      "lat": "58.1258",
      "lng": "25.3586",
      "country": "Estonia",
      "iso2": "EE",
      "admin_name": "Viljandimaa",
      "capital": "minor",
      "population": "1061",
      "population_proper": "1061"
    },
    {
      "city": "Uulu",
      "lat": "58.2800",
      "lng": "24.5761",
      "country": "Estonia",
      "iso2": "EE",
      "admin_name": "Pärnumaa",
      "capital": "minor",
      "population": "519",
      "population_proper": "519"
    },
    {
      "city": "Kuusalu",
      "lat": "59.4542",
      "lng": "25.4392",
      "country": "Estonia",
      "iso2": "EE",
      "admin_name": "Harjumaa",
      "capital": "minor",
      "population": "256",
      "population_proper": "256"
    },
    {
      "city": "Kurepalu",
      "lat": "58.3178",
      "lng": "26.8308",
      "country": "Estonia",
      "iso2": "EE",
      "admin_name": "Tartumaa",
      "capital": "minor",
      "population": "209",
      "population_proper": "209"
    },
    {
      "city": "Linaküla",
      "lat": "58.1361",
      "lng": "23.9683",
      "country": "Estonia",
      "iso2": "EE",
      "admin_name": "Pärnumaa",
      "capital": "minor",
      "population": "172",
      "population_proper": "172"
    },
    {
      "city": "Liiva",
      "lat": "58.6056",
      "lng": "23.2372",
      "country": "Estonia",
      "iso2": "EE",
      "admin_name": "Saaremaa",
      "capital": "minor",
      "population": "165",
      "population_proper": "165"
    },
    {
      "city": "Ruhnu",
      "lat": "57.8039",
      "lng": "23.2414",
      "country": "Estonia",
      "iso2": "EE",
      "admin_name": "Saaremaa",
      "capital": "minor",
      "population": "141",
      "population_proper": "141"
    },
    {
      "city": "Hullo",
      "lat": "58.9917",
      "lng": "23.2425",
      "country": "Estonia",
      "iso2": "EE",
      "admin_name": "Läänemaa",
      "capital": "minor",
      "population": "131",
      "population_proper": "131"
    },
    {
      "city": "Jõelähtme",
      "lat": "59.4439",
      "lng": "25.1292",
      "country": "Estonia",
      "iso2": "EE",
      "admin_name": "Harjumaa",
      "capital": "minor",
      "population": "111",
      "population_proper": "111"
    },
    {
      "city": "Loksa",
      "lat": "59.5692",
      "lng": "25.7311",
      "country": "Estonia",
      "iso2": "EE",
      "admin_name": "Harjumaa",
      "capital": "minor",
      "population": "48",
      "population_proper": "48"
    },
    {
      "city": "Viimsi",
      "lat": "59.5050",
      "lng": "24.8481",
      "country": "Estonia",
      "iso2": "EE",
      "admin_name": "Harjumaa",
      "capital": "minor",
      "population": "",
      "population_proper": ""
    },
    {
      "city": "Kohila",
      "lat": "59.1681",
      "lng": "24.7575",
      "country": "Estonia",
      "iso2": "EE",
      "admin_name": "Raplamaa",
      "capital": "minor",
      "population": "",
      "population_proper": ""
    },
    {
      "city": "Saku",
      "lat": "59.3035",
      "lng": "24.6638",
      "country": "Estonia",
      "iso2": "EE",
      "admin_name": "Harjumaa",
      "capital": "minor",
      "population": "",
      "population_proper": ""
    },
    {
      "city": "Väike-Maarja",
      "lat": "59.1264",
      "lng": "26.2500",
      "country": "Estonia",
      "iso2": "EE",
      "admin_name": "Lääne-Virumaa",
      "capital": "minor",
      "population": "",
      "population_proper": ""
    },
    {
      "city": "Kadrina",
      "lat": "59.3347",
      "lng": "26.1450",
      "country": "Estonia",
      "iso2": "EE",
      "admin_name": "Lääne-Virumaa",
      "capital": "minor",
      "population": "",
      "population_proper": ""
    },
    {
      "city": "Märjamaa",
      "lat": "58.9039",
      "lng": "24.4306",
      "country": "Estonia",
      "iso2": "EE",
      "admin_name": "Raplamaa",
      "capital": "minor",
      "population": "",
      "population_proper": ""
    },
    {
      "city": "Ülenurme",
      "lat": "58.3158",
      "lng": "26.7242",
      "country": "Estonia",
      "iso2": "EE",
      "admin_name": "Tartumaa",
      "capital": "minor",
      "population": "",
      "population_proper": ""
    },
    {
      "city": "Jüri",
      "lat": "59.3597",
      "lng": "24.9210",
      "country": "Estonia",
      "iso2": "EE",
      "admin_name": "Harjumaa",
      "capital": "minor",
      "population": "",
      "population_proper": ""
    },
    {
      "city": "Kose",
      "lat": "59.1789",
      "lng": "25.1731",
      "country": "Estonia",
      "iso2": "EE",
      "admin_name": "Harjumaa",
      "capital": "minor",
      "population": "",
      "population_proper": ""
    },
    {
      "city": "Vändra",
      "lat": "58.6481",
      "lng": "25.0361",
      "country": "Estonia",
      "iso2": "EE",
      "admin_name": "Pärnumaa",
      "capital": "minor",
      "population": "",
      "population_proper": ""
    },
    {
      "city": "Aruküla",
      "lat": "59.3669",
      "lng": "25.0762",
      "country": "Estonia",
      "iso2": "EE",
      "admin_name": "Harjumaa",
      "capital": "minor",
      "population": "",
      "population_proper": ""
    },
    {
      "city": "Sõmeru",
      "lat": "59.3611",
      "lng": "26.4375",
      "country": "Estonia",
      "iso2": "EE",
      "admin_name": "Lääne-Virumaa",
      "capital": "minor",
      "population": "",
      "population_proper": ""
    },
    {
      "city": "Nõo",
      "lat": "58.2756",
      "lng": "26.5375",
      "country": "Estonia",
      "iso2": "EE",
      "admin_name": "Tartumaa",
      "capital": "minor",
      "population": "",
      "population_proper": ""
    },
    {
      "city": "Järva-Jaani",
      "lat": "59.0386",
      "lng": "25.8864",
      "country": "Estonia",
      "iso2": "EE",
      "admin_name": "Järvamaa",
      "capital": "minor",
      "population": "",
      "population_proper": ""
    },
    {
      "city": "Kiili",
      "lat": "59.3077",
      "lng": "24.8378",
      "country": "Estonia",
      "iso2": "EE",
      "admin_name": "Harjumaa",
      "capital": "minor",
      "population": "",
      "population_proper": ""
    },
    {
      "city": "Iisaku",
      "lat": "59.1014",
      "lng": "27.3081",
      "country": "Estonia",
      "iso2": "EE",
      "admin_name": "Ida-Virumaa",
      "capital": "minor",
      "population": "",
      "population_proper": ""
    },
    {
      "city": "Rõuge",
      "lat": "57.7278",
      "lng": "26.9097",
      "country": "Estonia",
      "iso2": "EE",
      "admin_name": "Võrumaa",
      "capital": "minor",
      "population": "",
      "population_proper": ""
    },
    {
      "city": "Toila",
      "lat": "59.4213",
      "lng": "27.5081",
      "country": "Estonia",
      "iso2": "EE",
      "admin_name": "Ida-Virumaa",
      "capital": "minor",
      "population": "",
      "population_proper": ""
    },
    {
      "city": "Haljala",
      "lat": "59.4336",
      "lng": "26.2614",
      "country": "Estonia",
      "iso2": "EE",
      "admin_name": "Lääne-Virumaa",
      "capital": "minor",
      "population": "",
      "population_proper": ""
    },
    {
      "city": "Luunja",
      "lat": "58.3558",
      "lng": "26.8808",
      "country": "Estonia",
      "iso2": "EE",
      "admin_name": "Tartumaa",
      "capital": "minor",
      "population": "",
      "population_proper": ""
    },
    {
      "city": "Alatskivi",
      "lat": "58.5981",
      "lng": "27.1336",
      "country": "Estonia",
      "iso2": "EE",
      "admin_name": "Tartumaa",
      "capital": "minor",
      "population": "",
      "population_proper": ""
    },
    {
      "city": "Pajusti",
      "lat": "59.2744",
      "lng": "26.4233",
      "country": "Estonia",
      "iso2": "EE",
      "admin_name": "Lääne-Virumaa",
      "capital": "minor",
      "population": "",
      "population_proper": ""
    },
    {
      "city": "Harku",
      "lat": "59.3864",
      "lng": "24.5718",
      "country": "Estonia",
      "iso2": "EE",
      "admin_name": "Harjumaa",
      "capital": "minor",
      "population": "",
      "population_proper": ""
    },
    {
      "city": "Järvakandi",
      "lat": "58.7789",
      "lng": "24.8258",
      "country": "Estonia",
      "iso2": "EE",
      "admin_name": "Raplamaa",
      "capital": "minor",
      "population": "",
      "population_proper": ""
    },
    {
      "city": "Kanepi",
      "lat": "57.9831",
      "lng": "26.7564",
      "country": "Estonia",
      "iso2": "EE",
      "admin_name": "Põlvamaa",
      "capital": "minor",
      "population": "",
      "population_proper": ""
    },
    {
      "city": "Värska",
      "lat": "57.9581",
      "lng": "27.6381",
      "country": "Estonia",
      "iso2": "EE",
      "admin_name": "Põlvamaa",
      "capital": "minor",
      "population": "",
      "population_proper": ""
    },
    {
      "city": "Kõrveküla",
      "lat": "58.4242",
      "lng": "26.7822",
      "country": "Estonia",
      "iso2": "EE",
      "admin_name": "Tartumaa",
      "capital": "minor",
      "population": "",
      "population_proper": ""
    },
    {
      "city": "Taebla",
      "lat": "58.9539",
      "lng": "23.7522",
      "country": "Estonia",
      "iso2": "EE",
      "admin_name": "Läänemaa",
      "capital": "minor",
      "population": "",
      "population_proper": ""
    }
  ]
}
